var _path, _text, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSizeBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D3D",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#3D3D3D",
    d: "M3.5 3.5h151v38H3.5v-38z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24.5,
    y: 26.437,
    fill: "#3D3D3D",
    fontFamily: "Sabon LT Std",
    fontSize: 14,
    fontWeight: "bold"
  }, "\n        size\n    ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M133.515 23.229l-3.285 3.286-.745-.744L132.256 23l-2.771-2.77.745-.744 3.285 3.285-.229.229.229.229z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeBoxIcon);
export default __webpack_public_path__ + "static/media/size-box-icon.d6a85685809c43f5989af88c22602582.svg";
export { ForwardRef as ReactComponent };